"use client";

import { Phone, Mail } from "lucide-react";

export default function FooterContact() {
  return (
    <div className="space-y-6">
      <h4 className="text-white text-lg font-bold font-body relative">
        Get in Touch
        <div className="absolute -bottom-2 left-0 w-8 h-0.5 bg-[var(--color-rr-green)]"></div>
      </h4>
      
      <div className="space-y-4">
        <a
          href="tel:0477746329"
          className="flex items-center space-x-4 p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-[var(--color-rr-green)] hover:bg-gray-900/80 transition-all duration-300 group"
        >
          <div className="w-12 h-12 bg-[var(--color-rr-green)]/10 rounded-xl flex items-center justify-center group-hover:bg-[var(--color-rr-green)]/20 transition-colors">
            <Phone size={20} className="text-[var(--color-rr-green)]" />
          </div>
          <div className="font-body">
            <div className="text-white text-lg font-bold">04 77 746 329</div>
            <div className="text-gray-400 text-sm">Sales & Inquiries</div>
          </div>
        </a>
        
        <a
          href="tel:0477111731"
          className="flex items-center space-x-4 p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-[var(--color-rr-green)] hover:bg-gray-900/80 transition-all duration-300 group"
        >
          <div className="w-12 h-12 bg-[var(--color-rr-green)]/10 rounded-xl flex items-center justify-center group-hover:bg-[var(--color-rr-green)]/20 transition-colors">
            <Phone size={20} className="text-[var(--color-rr-green)]" />
          </div>
          <div className="font-body">
            <div className="text-white text-lg font-bold">04 77 111 731</div>
            <div className="text-gray-400 text-sm">Technical Support</div>
          </div>
        </a>
        
        <a
          href="mailto:info@rrequipmentrentals.com.au"
          className="flex items-center space-x-4 p-4 bg-gray-900/50 rounded-xl border border-gray-800 hover:border-[var(--color-rr-green)] hover:bg-gray-900/80 transition-all duration-300 group"
        >
          <div className="w-12 h-12 bg-[var(--color-rr-green)]/10 rounded-xl flex items-center justify-center group-hover:bg-[var(--color-rr-green)]/20 transition-colors">
            <Mail size={20} className="text-[var(--color-rr-green)]" />
          </div>
          <div className="font-body">
            <div className="text-white text-lg font-bold">Email Us</div>
            <div className="text-gray-400 text-sm">Quick response</div>
          </div>
        </a>
      </div>
    </div>
  );
}